/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignChannelUpdatePathParams, CampaignChannelUpdateResponse } from '../types/CampaignChannelUpdate'

/**
 * PUT /campaigns/:campaign/channels/:channel
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignChannelController.php CampaignChannelController::update
 */
export async function campaignChannelUpdate(
	campaign: CampaignChannelUpdatePathParams['campaign'],
	channel: CampaignChannelUpdatePathParams['channel'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignChannelUpdateResponse>> {
	return axiosInstance.put(`/campaigns/${campaign}/channels/${channel}`, undefined, config)
}
